module.exports = __webpack_public_path__ + "media/images/iconSocialX__inFrontOfAccent--dark-9ebf0cf8c7b4f35c8fe3e65928726921.png";